<template>
  <div class="page-layout">
    <!-- 头部 -->
    <div class="page-header">
      <div class="header-left">
        <a-icon type="left" :style="{fontSize:'25px'}" @click="goBack"/>
        <div class="logo">
          <img v-if="serverData.serverLogo" :src="serverData.serverLogo" alt="">
          <img v-else src="https://imgb.woyoubooking.com/common/hotel/user_default_icon.png" alt="">
        </div>
        <span class="router-name" v-if="serverData.serverName">{{ serverData.serverName }}</span>
        <span class="router-name" v-else>服务</span>
        <template v-if="menuList&&menuList.length>0">
          <a-menu v-model="current" mode="horizontal" class="menu-ul">
            <a-menu-item v-for="item in menuList" :key="String(item.name)" @click="tabMenuItem(item.name)">
              <router-link
                :to="{ name: item.name,query:{serverId:serverId,serverUniqueId:serverUniqueId,updateFlag:true}}">
                {{ item.title }}
              </router-link>
            </a-menu-item>
          </a-menu>
        </template>
      </div>
      <div class="header-right">
        <CustomRecharge v-if="isRecharge"></CustomRecharge>
        <changLianConfig v-if="showChangLian"/>
        <TuNiuConfig v-if="showTuNiu"/>
        <payContractNumber></payContractNumber>
        <span class="versions-text">当前版本：{{ serverData.versinoName }}</span>
        <!-- <a-button type="danger" ghost>升级版本</a-button> -->
      </div>
    </div>
    <!-- 内容区域 -->
    <a-layout :style="maxStyle?{padding:'24px','box-sizing': 'border-box'}:{margin:'24px auto 0',maxWidth:'1200px'}">
      <route-view/>
    </a-layout>
  </div>
</template>

<script>
import RouteView from './RouteView'
import CustomRecharge from '@/customComponents/CustomRecharge/CustomRecharge'
import payContractNumber from '@/views/service/serviceProvider/contract/components/payContractNumber'
import changLianConfig from '@/views/service/serviceProvider/changLianConnection/components/changLianConfig'
import TuNiuConfig from '@/views/service/serviceProvider/tuNiuConnection/components/TuNiuConfig'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CustomServiceLayout',
  components: {
    RouteView,
    CustomRecharge,
    payContractNumber,
    changLianConfig,
    TuNiuConfig
  },
  data() {
    return {
      maxStyle: false,
      serverUniqueId: this.$route.query.serverUniqueId,
      serverId: this.$route.query.serverId,
      current: [String(sessionStorage.getItem('menuKey'))],
      serverData: {}
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      menuList: state => state.config.menuList,
      isRecharge: state => state.config.isRecharge,
      showChangLian: state => state.config.showChangLian,
      showTuNiu: state => state.config.showTuNiu
    })
  },
  created() {
    this.getServerVersion()
  },
  watch: {
    $route(to, from) {
      this.maxStyle = this.$route.meta && this.$route.meta.maxStyle
      let list = this.menuList.find(item => to.name.indexOf(item.name) != -1)
      if (list && list.name) {
        this.current = [list.name]
        sessionStorage.setItem('menuKey', list.name)
      }
    }
  },
  mounted() {
    this.maxStyle = this.$route.meta && this.$route.meta.maxStyle
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    tabMenuItem(name) {
      console.log('tabMenuItem', name)
      sessionStorage.setItem('menuKey', name)
    },
    // 获取服务版本信息
    getServerVersion() {
      let serverUniqueId = this.$route.query.serverUniqueId
      if (serverUniqueId) {
        this.getHttpServices().getServerApiService().post('order/getServerVersion', {
          merchantId: this.$store.getters.userInfo.merchantId,
          serverUniqueId: this.$route.query.serverUniqueId,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          this.getLogUtils().logWithTag('==getServerVersion==', res)
          this.serverData = res
          this.$store.commit('SET_SERVER_DATA', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../components/global.less');

.page-layout {
  background: #f0f2f5;
  min-height: 100%;
  width: 100%;

  .page-header {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2%;
    height: 60px;

    .header-left {
      display: flex;
      align-items: center;

      .menu-ul {
        position: relative;
        top: 6px;

        a {
          font-size: 16px;
        }
      }

      .logo {
        width: 45px;
        height: 45px;
        margin-left: 10px;
        margin-right: 15px;

        img {
          width: 45px;
          height: 45px;
        }
      }

      .router-name {
        font-size: 18px;
        padding-right: 15px;
      }
    }

    .price-text {
      padding-right: 15px;
    }

    .versions-text {
      padding-left: 15px;
      padding-right: 10px;
    }
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
